import { Icon } from "@mui/material";
import React, { useState } from "react";
import { IColuna } from "../../../types/IColuna";
const estiloGridUltimasCompras =
  require("../ultimas-compras.module.scss").default;

export type MenuColunasUltimasComprasProps = {
  colunas: IColuna[];
  onToggleColunaSelecionada: (colunas: IColuna[]) => void;
};

export const MenuColunasUltimasCompras = (props: MenuColunasUltimasComprasProps) => {
  const [exibindo, setExibindo] = useState(false);
  const [colunas, setColunas] = useState(props.colunas);

  return (
    <div>
      <div
        onClick={() => setExibindo(!exibindo)}
        className={`_cursor-pointer" ${estiloGridUltimasCompras.gridButton}`}
        style={{ padding: "3.75px" }}
      >
        <Icon fontSize="small">settings</Icon>

        <Icon>{exibindo ? "arrow_drop_up" : "arrow_drop_down"}</Icon>
      </div>

      <div className="_grid _grid-rows-5 _grid-flow-col">
        {exibindo &&
          props.colunas.map((coluna, index) => (
            <div
              className="_flex _flex-row _justify-start _max-w-xs _items-end"
              key={index}
            >
              <input
                type="checkbox"
                className="_mr-4"
                checked={coluna.Selecionada ?? false}
                onChange={() => {
                  coluna.Selecionada = !coluna.Selecionada;
                  setColunas([...colunas]);
                  props.onToggleColunaSelecionada([...colunas]);
                }}
              />
              {coluna.Nome}
            </div>
          ))}
      </div>
    </div>
  );
};
